import { render, staticRenderFns } from "./register_protocol.vue?vue&type=template&id=081789cd&scoped=true"
import script from "./register_protocol.vue?vue&type=script&lang=js"
export * from "./register_protocol.vue?vue&type=script&lang=js"
import style0 from "./register_protocol.vue?vue&type=style&index=0&id=081789cd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "081789cd",
  null
  
)

export default component.exports